__turbopack_context__.v({
  "blue": "_8ZBTCa_blue",
  "btn": "_8ZBTCa_btn",
  "childrenWrapper": "_8ZBTCa_childrenWrapper",
  "col": "_8ZBTCa_col",
  "control": "_8ZBTCa_control",
  "desc": "_8ZBTCa_desc",
  "green": "_8ZBTCa_green",
  "name": "_8ZBTCa_name",
  "optionRoot": "_8ZBTCa_optionRoot",
  "orange": "_8ZBTCa_orange",
  "red": "_8ZBTCa_red",
  "root": "_8ZBTCa_root",
  "row": "_8ZBTCa_row",
});
